module.exports = __webpack_public_path__ + "static/media/gaming16.4b0cf5bd.webp";